import { z } from "zod";

// Body of POST /api/partners/:id/users/invite — mirrors the legacy
// (email, name, roleAtPartner) tuple from /app/admin/partners/_actions.ts
// ::invitePartnerContact.
export const partnerContactInviteSchema = z.object({
  email: z.string().trim().email().max(320),
  name: z.string().trim().max(200).optional().default(""),
  roleAtPartner: z.string().trim().max(200).optional().default(""),
});

export type PartnerContactInviteInput = z.infer<typeof partnerContactInviteSchema>;

export const partnerUserRoleUpdateSchema = z.object({
  role: z.string().trim().max(200),
});

export type PartnerUserRoleUpdateInput = z.infer<typeof partnerUserRoleUpdateSchema>;

export const partnerUserPrimaryToggleSchema = z.object({
  primary: z.boolean(),
});

export type PartnerUserPrimaryToggleInput = z.infer<typeof partnerUserPrimaryToggleSchema>;
